let engine;

export const setEngine = (data => {
    engine = data;
})

export const getEngine = () => {
    return engine;
}


/** WEBPACK FOOTER **
 ** ./src/util/engine.js
 **/